<template>
    <div>
        <SettingsList ref="child" :title="$t('products.plural')" :headers="headers" :items="items"
                      :loading="loading" :url="url" :add_button_title="$t('products.create')"
                      :delete_text="$t('products.delete')"
                      :delete_confirmation_text="$t('products.delete_confirmation')" @show-dialog="showDialog"
                      @view-dialog="showDialog" @update-dialog="showDialog" @get-data="getData">
        </SettingsList>

        <!--Tag Dialog-->
        <Dialog :show="show_item_dialog" max_width="50%" :header="item_dialog_header"
                :is_loading="item_dialog_loading" :action="item_action" @close-dialog="closeItemDialog"
                @submit-dialog="submitItemDialog">
            <template slot="content">
                <v-form autocomplete="off" class="white_bg_form">
                    <v-row dense>
                        <v-col cols="6">
                            <v-select name="category_id" v-model="item.category_id" class="custom_field" outlined
                                      :items="product_categories" :label="$t('categories.category')"
                                      item-text="category" :disabled="isDisabled" item-value="id"
                                      :error-messages="fieldErrors('category_id')">
                                <template slot="selection" slot-scope="data">
                                    <!-- HTML that describe how select should render selected items -->
                                    {{ data.item.category }}
                                </template>
                                <template slot="item" slot-scope="data">
                                    <!-- HTML that describe how select should render items when the select is open -->
                                    {{ data.item.category }}
                                </template>
                            </v-select>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field name="price" type="number" class="custom_field" v-model="item.price"
                                          :label="$t('products.price')" outlined clearable :disabled="isDisabled"
                                          @input="$v.item.price.$touch()" @blur="$v.item.price.$touch()"
                                          :error-messages="fieldErrors('price')">
                            </v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-select name="vat_value" v-model="item.vat_id" class="custom_field" outlined
                                      :items="vats" :label="$t('general.vat')" item-text="vat_value"
                                      :disabled="isDisabled" item-value="id" outlined>
                                <template slot="selection" slot-scope="data">
                                    <!-- HTML that describe how select should render selected items -->
                                    {{ data.item.vat_value }} %
                                </template>
                                <template slot="item" slot-scope="data">
                                    <!-- HTML that describe how select should render items when the select is open -->
                                    {{ data.item.vat_value }} %
                                </template>
                            </v-select>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="10">
                            <v-text-field name="product" type="text" class="custom_field" v-model="item.product"
                                          :label="$t('products.product')" outlined clearable :disabled="isDisabled"
                                          @input="$v.item.product.$touch()" @blur="$v.item.product.$touch()"
                                          :error-messages="fieldErrors('product')" @keyup="$Helper.methods.uppercase">
                            </v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <v-text-field name="stock" type="number" class="custom_field" v-model="item.stock"
                                          :label="$t('products.stock')" outlined clearable :disabled="isDisabled"
                                          @input="$v.item.stock.$touch()" @blur="$v.item.stock.$touch()"
                                          :error-messages="fieldErrors('stock')">
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-form>
            </template>
        </Dialog>
    </div>
</template>

<script>
    import SettingsList from '../../components/SettingsList.vue'
    import Dialog from '../../components/Dialog.vue'
    import {validationMixin} from 'vuelidate'
    import {required, numeric} from 'vuelidate/lib/validators'

    const bigger_than_zero = (value) => value > 0;

    export default {
        components: {
            SettingsList, Dialog
        },
        mixins: [validationMixin],
        validations: {
            item: {
                category_id: {required},
                product: {required},
                stock: {
                    minValue: bigger_than_zero
                },
                price: {
                    minValue: bigger_than_zero
                },
            }
        },
        data: self => ({
            product_categories: [],
            vats: [],
            // datatable
            headers: [],
            items: [],
            loading: false,
            url: 'product',

            // dialog
            show_item_dialog: false,
            item_dialog_header: null,
            item_dialog_loading: false,
            item: {
                category_id: null,
                product: null,
                stock: 1,
                price: null,
                vat_id: 2
            },
            item_id: null,
            item_action: null
        }),
        computed: {
            isDisabled() {
                return this.item_action === 'view';
            },
            locale() {
                return this.$i18n.locale;
            }
        },
        created() {
            this.headers = this.getHeaders();
        },
        async mounted() {
            this.getData();

            // get list of product categories
            let cats_response = await this.$store.dispatch('apiRequest', {
                method: 'get', url: 'settings/product_categories'
            });
            this.product_categories = cats_response.data;

            // get list ot vats
            let vats_response = await this.$store.dispatch('apiRequest', {
                method: 'get', url: 'settings/vats'
            });

            this.vats = vats_response.data;
        },
        watch: {
            locale(val) {
                this.headers = this.getHeaders();
            }
        },
        methods: {
            // return headers array
            getHeaders() {
                return [
                    {text: `${this.$t('categories.category')}`, value: 'category', sortable: true},
                    {text: `${this.$t('general.description')}`, value: 'product', sortable: true},
                    {text: `${this.$t('general.price')} €`, value: 'price', sortable: true},
                    {text: `${this.$t('general.vat')}`, value: 'vat_value', sortable: true},
                    {text: `${this.$t('datatable.actions')}`, value: 'actions', align: 'right', sortable: false}
                ];
            },

            // form field errors
            fieldErrors(prop) {
                const errors = [];
                if (!this.$v.item[prop].$dirty) return errors;
                !this.$v.item[prop].required && !this.$v.item[prop].minValue && errors.push(this.$t('validation.required'));
                return errors;
            },
            // get data from API
            async getData() {
                this.loading = true;
                let response = await this.$store.dispatch('apiRequest', {
                    method: 'get',
                    url: `${this.url}/index`
                });

                // successful response
                if (!response.response) {
                    this.items = response.data;
                }

                this.loading = false;
            },
            // show item dialog
            showDialog(item, action) {
                this.show_item_dialog = true;
                this.item_action = action;
                this.item_dialog_header = action === 'create' ? this.$t('products.create') :
                    action === 'view' ? this.$t('products.view') : this.$t('products.update');

                if (item) {
                    this.setItemInfo(item);
                }
            },
            // set item info for update and view
            setItemInfo(item) {
                this.item_id = item.id;

                for (let prop in this.item) {
                    this.item[prop] = item[prop];
                }
            },
            // close item dialog
            closeItemDialog() {
                this.$v.item.$reset();
                this.show_item_dialog = false;
                this.item_id = null;
                this.item_action = null;

                for (let prop in this.item) {
                    this.item[prop] = null;
                }
                this.item['vat_id'] = 2;
                this.item['stock'] = 1;
            },
            // submit item dialog
            async submitItemDialog() {
                this.$v.item.$touch();
                // login data are valid
                if (!this.$v.item.$invalid) {
                    this.item_dialog_loading = true;
                    let item = Object.assign({}, this.item);

                    let response = await this.$refs.child.submitItem(item, this.item_id);


                    // stop dialog submit button loading
                    this.item_dialog_loading = false;

                    // successful response
                    if (!response.response) {

                        // close item dialog
                        this.closeItemDialog();

                        // get items
                        this.getData();
                    }
                }
            }
        }
    }
</script>